import { getIsoLocaleFromCountry } from "../internationalization/features/locales";
import { getFormLink, getOrganizationPageLink, getOrganizationPageNewsletterUrl, getTicketingLink, } from "../routes";
import { getIsoLocalesFromFields } from "./locales";
export const getDonationFormCanonicalTags = ({ frontendUrl, donationForm, fieldsLocales, country, }) => {
    const isoLocales = getIsoLocalesFromFields(fieldsLocales, country);
    const mainIsoLocale = getIsoLocaleFromCountry(country, donationForm.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${getFormLink(donationForm, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${getFormLink(donationForm, isoLocale)}`;
            return acc;
        }, {}),
    };
};
export const getTicketingCanonicalTags = ({ frontendUrl, ticketing, fieldsLocales, country, }) => {
    const isoLocales = getIsoLocalesFromFields(fieldsLocales, country);
    const mainIsoLocale = getIsoLocaleFromCountry(country, ticketing.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${getTicketingLink(ticketing.path, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${getTicketingLink(ticketing.path, isoLocale)}`;
            return acc;
        }, {}),
    };
};
export const getOrganizationPageCanonicalTags = ({ frontendUrl, organizationPage, fieldsLocales, country, }) => {
    const isoLocales = getIsoLocalesFromFields(fieldsLocales, country);
    const mainIsoLocale = getIsoLocaleFromCountry(country, organizationPage.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${getOrganizationPageLink(organizationPage.path, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${getOrganizationPageLink(organizationPage.path, isoLocale)}`;
            return acc;
        }, {}),
    };
};
export const getOrganizationPageNewsletterCanonicalTags = ({ newsletterId, ...organizationPageTagsParams }) => {
    const organizationPageTags = getOrganizationPageCanonicalTags(organizationPageTagsParams);
    return {
        url: getOrganizationPageNewsletterUrl(organizationPageTags.url, newsletterId),
        default: getOrganizationPageNewsletterUrl(organizationPageTags.default, newsletterId),
        alternate: Object.fromEntries(Object.entries(organizationPageTags.alternate ?? {}).map(([isoLocale, url]) => [
            isoLocale,
            getOrganizationPageNewsletterUrl(url, newsletterId),
        ])),
    };
};
